import{Logger as r}from"aws-amplify";var n=function(n){return new r("AmplifyUI:".concat(n))};export{n as getLogger};
